import { STATUS } from "@/lib/format";

export default function StatusBadge({ status, testId }) {
  const s = STATUS[status] || STATUS.new;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 border px-2.5 py-1 text-[0.6rem] tracking-[0.14em] uppercase font-medium whitespace-nowrap ${s.cls}`}>
      <span className="h-1 w-1 rounded-full bg-current" />
      {s.label}
    </span>
  );
}
